import { Qualification } from '../models';
import { QUALIFICATIONS_RENDER_TYPE } from '../constants';

export class QualificationKind {
  private static readonly _coreRenderTypes: number[] = [
    QUALIFICATIONS_RENDER_TYPE.MULTIPUNCH_DROPDOWN,
    QUALIFICATIONS_RENDER_TYPE.RANGE,
  ];

  public static isCore(qualification: Qualification): boolean {
    return this._coreRenderTypes.includes(qualification.renderType);
  }

  public static isLocation(qualification: Qualification): boolean {
    return qualification.isLocation;
  }

  public static core(qualifications: Qualification[]): Qualification[] {
    return qualifications.filter((qualification) =>
      QualificationKind.isCore(qualification),
    );
  }

  public static location(qualifications: Qualification[]): Qualification[] {
    return qualifications.filter((qualification) =>
      QualificationKind.isLocation(qualification),
    );
  }
}
